import { render, staticRenderFns } from "./PositionAvatar.vue?vue&type=template&id=d3adafba&"
import script from "./PositionAvatar.vue?vue&type=script&lang=js&"
export * from "./PositionAvatar.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/quoteFonts.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./PositionAvatar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports